var _test_girl_id=1;
function init_lickanim(from_php){
    var main=$(".place.lickanim");
    var qcanv=main.find(".canvWrap[data-type='win'] .canvMain");
    var conf={
        "win":$.takeGirlConf(from_php.girl_id,"lick_win"),
        "lose":$.takeGirlConf(from_php.girl_anim_id,"lick_lose")
    };
    var imagesObj={
        "win":{
            girl_id:from_php.girl_id
        },
        "lose":{
            girl_id:from_php.girl_anim_id
        }
        
    };   
    function init(){
        
        var imagesObj={
            "1":{
                conf:{period_min:50,period_max:100},
                arr:[
                    {
                        path:_IMG_SERV+"/gfx/place/lickanim/girls/"+$.takeGirlImage(from_php.girl_id)+"/win/anim.png",
                        conf:$.takeGirlConf(from_php.girl_id,"lick_win")
                    },
                    {
                        path:_IMG_SERV+"/gfx/place/lickanim/girls/"+$.takeGirlImage(from_php.girl_anim_id)+"/lose/anim.png",
                        conf:$.takeGirlConf(from_php.girl_anim_id,"lick_lose")
                    },
                ]
            }
        };
        if(typeof $.takeGirlConf(from_php.girl_id,"lick_win_leg").width!="undefined"){
            imagesObj["1"].arr.push({
                path:_IMG_SERV+"/gfx/place/lickanim/girls/"+$.takeGirlImage(from_php.girl_id)+"/win_leg/anim.png",
                conf:$.takeGirlConf(from_php.girl_id,"lick_win_leg")
            }); 
        }
        var qcanv=main.find(".canvWrap .canvMain");
        qcanv.off("was_loaded").one("was_loaded",function(){
            qcanv.animCircleLoop("start");
                
        }).animCircleLoop({},imagesObj,_moduleTimeHandler);
        
    }
    init();
    
    
            
    function initReward(){
        var win=main.find("#rewardWin");
        if(!win.length){
            return false;
        }
        win.find("#rewardButJS").click(function(){
           win.remove();
           var to_send={page:"lickanim","girl_id":from_php.girl_id,give_reward:1};
           $.mypost('/ajax',to_send, function(res) {
                var data=handleAjaxRes(res);
                if(typeof data!="undefined" && data){
                    
                }
            },"json");
        });
        return true;
        
    }
    initReward();
    $("#qTestAnim").click(function(){
        $.goToLocation("lickanim/"+_test_girl_id+"/"+(20-_test_girl_id));
        _test_girl_id++;
        if(_test_girl_id>19){
            _test_girl_id=1;
        }
    });
    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px")
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });
    
    function initCanvas(){
        var settings={width:1280,height:780};
        var canv=main.find("#canvBack");
        var ctx=canv[0].getContext("2d");
        var img=new Image();
        img.src="/gfx/place/lickanim/sponge.png";
        ctx.clearRect(0, 0, settings.width, settings.height);
        ctx.save();
        ctx.beginPath();
        ctx.fillStyle = 'rgba(255,255,255,0.7)';
        ctx.rect(0, 0,settings.width, settings.height);
        ctx.fill();
        ctx.restore();
        _moduleTimeHandler.add(function(){
            ctx.save();
            ctx.beginPath();
            ctx.fillStyle = 'rgba(255,255,255,0.01)';
            ctx.rect(0, 0,settings.width, settings.height);
            ctx.fill();
            ctx.restore();
        },300);
        
        var useSponge=0, pos=[],pos_last=[],spongeWasInit=0;
        var canvGhost=main.find("#canvGhost"),spongeSoundName,
        spongeIndex=_moduleTimeHandler.getNewIndex(),spongeEndIndex=_moduleTimeHandler.getNewIndex();
        canvGhost.on("mousedown touchstart",function(){
            useSponge=1;
            spongeWasInit=1;
            
            
            
        }).on("mouseup touchend",function(){
            useSponge=0;
            _moduleTimeHandler.clear(spongeIndex);
            pos_last=[];
        });
        function drawArr(arr){
            ctx.save();
            ctx.globalCompositeOperation = 'destination-out';
            var i, pos;
            for(i in arr){
                pos=arr[i];
                drawImage(ctx,img,pos[0],pos[1]);
            }
            ctx.restore();
        }
        var spongeObj=main.find("#spongeJS");
        var sponge_size=[spongeObj.width(),spongeObj.height()];
        canvGhost.on("mousemove touchmove",function(e){
            //$.getXeventOffset
            //$.getYeventOffset
            if(useSponge){
                
                pos=[$.getXeventOffset(e),$.getYeventOffset(e)];
                if(pos_last.length==0){
                    pos_last=copyArray(pos);
                }
                var qvec=minusVector(pos,pos_last),vec_cur,distance=lengthVector(qvec),
                step_max=0,step=0;
                step_max=1+Math.round(distance/8);
                if(distance>10){
                    if(!_moduleTimeHandler.isIndexSet(spongeIndex)){
                        _moduleTimeHandler.set(spongeIndex,function(){
                            spongeSoundName=_mySound.playSound("window_clean");
                        },4000,function(){
                            _mySound.stopSound(spongeSoundName);
                        });
                    }
                    _moduleTimeHandler.clear(spongeEndIndex);
                    _moduleTimeHandler.setOne(spongeEndIndex,function(){
                        _moduleTimeHandler.clear(spongeIndex);
                    },400);
                }
                
                var arr=[];
                for(step=1;step<=step_max;step++){
                    vec_cur=[
                        pos_last[0]+Math.round(qvec[0]*step/step_max),
                        pos_last[1]+Math.round(qvec[1]*step/step_max)
                    ];
                    arr.push(vec_cur);
                }
                drawArr(arr);
                
                
                pos_last=copyArray(pos);
                spongeObj.css({
                    left:Math.round(pos[0]-sponge_size[0]/2)+"px",
                    top:Math.round(pos[1]-sponge_size[1]/2)+"px"
                });
            }
            e.preventDefault();
        });
        function spongeHelp(){
            var angle=0,start=[700,200],angle_pi,pos=[];
            var indexSponge=_moduleTimeHandler.getNewIndex();
            
            _moduleTimeHandler.set(indexSponge,function(){
                angle=(angle+2)%360;
                angle_pi=angle/180*Math.PI;
                pos[0]=start[0]+50*Math.cos(angle_pi);
                pos[1]=start[1]+50*Math.sin(angle_pi);
                spongeObj.css({
                    left:Math.round(pos[0]-sponge_size[0]/2)+"px",
                    top:Math.round(pos[1]-sponge_size[1]/2)+"px"
                });
                drawArr([pos]);
                if(spongeWasInit){
                   _moduleTimeHandler.clear(indexSponge); 
                }
            },40);
        }
        spongeHelp();
    }
    function prepareSmoke(){
        var smoke=main.find("#qsmoke"),step=0,step_max=3,opacity=0,opacity_max=80,dir=5;
        var indexOpacity=_moduleTimeHandler.getNewIndex();
        smoke.css("opacity",0);
        function makeStep(){
            opacity=0;
            dir=Math.abs(dir);
            step=(step+1)%step_max;
            smoke.css("background-position",(-1280*step)+"px 0px");
            _moduleTimeHandler.set(indexOpacity,function(){
                opacity+=dir;
                if(opacity>=opacity_max){
                    dir*=-1;
                    opacity=Math.min(opacity,opacity_max);
                }
                if(opacity<=0){
                    opacity=0;
                }
                smoke.css("opacity",Math.min(0.6,opacity/100));
                if(opacity==0){
                    _moduleTimeHandler.clear(indexOpacity);
                    makeStep();
                }
                
            },40);
        }
        makeStep();
    }
    function init_sound(){
        var showerName=_mySound.playSound("shower");
        _moduleEvents.one("moduleClear",function(){
            _mySound.stopSound(showerName);
        });
        var indexOrg=_moduleTimeHandler.getNewIndex();
        _moduleTimeHandler.add(function(){
            _mySound.playSound("girl_org");
            
        },5000);
    }
    prepareSmoke();
    init_sound();
//    main.find("#qsmoke").qAnim({clips:3,width:1280,interval:350,loop:1})
    
    $("<div/>").one("myload",function(){
        initCanvas();
    }).myLoad(["/gfx/place/lickanim/sponge.png"]);
    
    
    if(from_php.force_url){
         _semaphoreXHR.addForceLocation(from_php.force_url);
    }
}